import * as approvalFacadeImpl from "./approvalFacadeImpl";
import * as associatedFileCategoryFacadeImpl from "./associatedFileCategoryFacadeImpl";
import * as batchStep from "./batchStep";
import * as changeApproval from "./changeApproval";
import * as loginResourceSupportFacadeImpl from "./loginResourceSupportFacadeImpl";
import * as logisticsSupplierSkuFacadeImpl from "./logisticsSupplierSkuFacadeImpl";
import * as procurementOrder from "./procurementOrder";
import * as procurementRemark from "./procurementRemark";
import * as settlementMethodFacadeImpl from "./settlementMethodFacadeImpl";
import * as supplierAccountAncillaryInfo from "./supplierAccountAncillaryInfo";
import * as supplierAccountDetailsImpl from "./supplierAccountDetailsImpl";
import * as supplierAccountMaster from "./supplierAccountMaster";
import * as supplierBankAccount from "./supplierBankAccount";
import * as supplierBox from "./supplierBox";
import * as supplierBoxBatch from "./supplierBoxBatch";
import * as supplierBoxFacadeImpl from "./supplierBoxFacadeImpl";
import * as supplierBoxGaugeUpdateRecord from "./supplierBoxGaugeUpdateRecord";
import * as supplierContacts from "./supplierContacts";
import * as supplierDeliveryOrder from "./supplierDeliveryOrder";
import * as supplierDeliveryOrderFacadeImpl from "./supplierDeliveryOrderFacadeImpl";
import * as supplierEbs from "./supplierEbs";
import * as supplierInfo from "./supplierInfo";
import * as supplierInfoFacadeImpl from "./supplierInfoFacadeImpl";
import * as supplierOrganizationalUnit from "./supplierOrganizationalUnit";
import * as supplierPad from "./supplierPad";
import * as supplierProduct from "./supplierProduct";
import * as supplierPurchaseOrder from "./supplierPurchaseOrder";
import * as supplierQuotation from "./supplierQuotation";
import * as supplierQuotationFacadeImpl from "./supplierQuotationFacadeImpl";
import * as supplierSn from "./supplierSn";
import * as supplierSnBatch from "./supplierSnBatch";
import * as supplierSnOperateRecord from "./supplierSnOperateRecord";
import * as supplierSnSearch from "./supplierSnSearch";

export const srm = {
  approvalFacadeImpl,
  associatedFileCategoryFacadeImpl,
  batchStep,
  changeApproval,
  loginResourceSupportFacadeImpl,
  logisticsSupplierSkuFacadeImpl,
  procurementOrder,
  procurementRemark,
  settlementMethodFacadeImpl,
  supplierAccountAncillaryInfo,
  supplierAccountDetailsImpl,
  supplierAccountMaster,
  supplierBankAccount,
  supplierBox,
  supplierBoxBatch,
  supplierBoxFacadeImpl,
  supplierBoxGaugeUpdateRecord,
  supplierContacts,
  supplierDeliveryOrder,
  supplierDeliveryOrderFacadeImpl,
  supplierEbs,
  supplierInfo,
  supplierInfoFacadeImpl,
  supplierOrganizationalUnit,
  supplierPad,
  supplierProduct,
  supplierPurchaseOrder,
  supplierQuotation,
  supplierQuotationFacadeImpl,
  supplierSn,
  supplierSnBatch,
  supplierSnOperateRecord,
  supplierSnSearch,
};
